// اقتراح «كود الشركة» (slug) من اسمها — تحويل الحروف العربية إلى لاتينية.
const MAP = {
  'ا': 'a', 'أ': 'a', 'إ': 'a', 'آ': 'a', 'ء': 'a', 'ى': 'a', 'ة': 'a',
  'ب': 'b', 'ت': 't', 'ث': 'th', 'ج': 'j', 'ح': 'h', 'خ': 'kh',
  'د': 'd', 'ذ': 'dh', 'ر': 'r', 'ز': 'z', 'س': 's', 'ش': 'sh',
  'ص': 's', 'ض': 'd', 'ط': 't', 'ظ': 'z', 'ع': 'a', 'غ': 'gh',
  'ف': 'f', 'ق': 'q', 'ك': 'k', 'ل': 'l', 'م': 'm', 'ن': 'n',
  'ه': 'h', 'و': 'w', 'ي': 'y', 'ئ': 'y', 'ؤ': 'w',
  'پ': 'p', 'چ': 'ch', 'ژ': 'zh', 'گ': 'g', 'ک': 'k', 'ی': 'y',
  '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
  '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
};

export const SLUG_MIN = 2;
export const SLUG_MAX = 32;
export const SLUG_RE = /^[a-z0-9-]{2,32}$/;

export function slugify(name = '') {
  const out = [];
  for (const ch of String(name).toLowerCase()) {
    if (MAP[ch]) { out.push(MAP[ch]); continue; }
    if (/[a-z0-9]/.test(ch)) { out.push(ch); continue; }
    out.push('-');
  }
  return out
    .join('')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, SLUG_MAX)
    .replace(/-$/, '');
}

/** تنظيف ما يكتبه المستخدم مباشرة في حقل الكود (بدون قصّ الشرطات الطرفية أثناء الكتابة). */
export function cleanSlugInput(value = '') {
  const out = [];
  for (const ch of String(value).toLowerCase()) {
    if (MAP[ch]) { out.push(MAP[ch]); continue; }
    if (/[a-z0-9-]/.test(ch)) { out.push(ch); continue; }
    out.push('-');
  }
  return out.join('').replace(/-{2,}/g, '-').slice(0, SLUG_MAX);
}

/** رسالة خطأ عربية أو null إذا كان الكود سليماً. */
export function slugError(value = '') {
  const v = String(value);
  if (!v) return 'كود الشركة مطلوب';
  if (v.length < SLUG_MIN) return `الكود قصير جداً (الحد الأدنى ${SLUG_MIN} حرفين)`;
  if (v.length > SLUG_MAX) return `الكود طويل جداً (الحد الأعلى ${SLUG_MAX} حرفاً)`;
  if (!SLUG_RE.test(v)) return 'يُسمح بالحروف الإنجليزية الصغيرة والأرقام والشرطة (-) فقط';
  if (v.startsWith('-') || v.endsWith('-')) return 'لا يبدأ الكود ولا ينتهي بشرطة';
  return null;
}
